let newsletterModule;

async function loadNewsletter(holder) {
    if (!newsletterModule) {
        newsletterModule = Promise.all([
            import('../../../packages/theme/Resources/Public/css/newsletter.css'),
            import(/* @vite-ignore */ holder.dataset.newsletterScript),
        ]).then(([, module]) => module);
    }
    const module = await newsletterModule;
    module.initNewsletterDialog();
    return module;
}

export function initNewsletterLoader() {
    const holder = document.querySelector('[data-newsletter-script]');
    const openerContainer = holder?.querySelector('.subscribe-opener');
    const opener = holder?.querySelector('.subscribe-opener a');
    if (!holder || !openerContainer || !opener) return;

    const updateOpener = () => {
        openerContainer.classList.toggle('hidden', window.scrollY > 20);
    };
    window.addEventListener('scroll', updateOpener, {passive: true});
    updateOpener();

    const preload = () => loadNewsletter(holder).catch(() => {});
    opener.addEventListener('pointerenter', preload, {once: true});
    opener.addEventListener('focus', preload, {once: true});
    opener.addEventListener('click', async (event) => {
        event.preventDefault();
        const returnFocusTarget = event.currentTarget;
        try {
            const module = await loadNewsletter(holder);
            module.openNewsletterDialog(holder.querySelector('.subscribe-popup'), returnFocusTarget);
        } catch (error) {
            window.console.error('Newsletter dialog could not be loaded.', error);
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewsletterLoader, {once: true});
} else {
    initNewsletterLoader();
}
